import { profile } from "./profile"
import { state } from "./state"
import { host } from "./host"
import { join } from "./join"
import { cards } from "./cards"

import { writable } from "svelte/store"
import { tweened } from 'svelte/motion'

import { cubicOut } from 'svelte/easing'

const pick = writable()
const options = writable([])
const pickedOption = writable("")
const pickedReady = writable("")
const showProfile = writable(false)
const userData = writable(false)
const showMessage = writable(false)
const crash = writable()
const position = writable("")
const version = writable({frontend:"unknown", backend: "unknown"})
const points = tweened(0, {
    duration: 1000,
    easing: cubicOut
})

export { profile, state, host, join, cards, pick, options, pickedOption, pickedReady, showProfile, userData, points, position, showMessage, version, crash }

export default { profile, state, host, join, cards, pick, options, pickedOption, pickedReady, showProfile, userData, points, position, showMessage, version, crash }